import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = ({ darkTheme = true }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}! We'll get back to you shortly.`);
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  // Theme-based colors
  const bgColor = darkTheme ? "#0a0a0a" : "#f8f9fa";
  const sectionBg = darkTheme ? "#111" : "#fff";
  const textColor = darkTheme ? "#fff" : "#111";
  const subTextColor = darkTheme ? "#ccc" : "#666";
  const borderColor = darkTheme ? "#222" : "#e5e5e5";
  const cardBg = darkTheme ? "#0a0a0a" : "#f8f9fa";
  const inputBg = darkTheme ? "#111" : "#fff";
  const inputColor = darkTheme ? "#fff" : "#111";

  return (
    <div style={{ paddingTop: "80px" }}>
      {/* HERO SECTION */}
      <section style={{
        padding: "6rem 2rem 4rem",
        backgroundColor: bgColor,
        textAlign: "center",
      }}>
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          <span style={{
            color: "#ff0000",
            fontSize: "0.9rem",
            fontWeight: "600",
            letterSpacing: "2px",
            textTransform: "uppercase",
            marginBottom: "1rem",
            display: "block",
          }} data-aos="fade-down">
            GET IN TOUCH
          </span>
          <h1 style={{
            fontSize: "3rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: textColor,
            lineHeight: "1.2",
          }} data-aos="fade-up">
            Let's Start a Conversation
          </h1>
          <p style={{
            fontSize: "1.2rem",
            lineHeight: "1.8",
            color: subTextColor,
            marginBottom: "2.5rem",
            maxWidth: "700px",
            margin: "0 auto",
          }} data-aos="fade-up" data-aos-delay="100">
            Whether you're looking for management, bookings, or collaboration opportunities,
            we're here to help you succeed.
          </p>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section style={{ padding: "5rem 2rem", backgroundColor: sectionBg }}>
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4rem" }}>
            {/* LEFT SIDE - Contact Info */}
            <div data-aos="fade-right">
              <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "1rem", color: textColor }}>
                Contact Information
              </h2>
              <p style={{ fontSize: "1.1rem", color: subTextColor, marginBottom: "3rem", lineHeight: "1.7" }}>
                Reach out to us for professional talent management services, bookings,
                and partnership opportunities.
              </p>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem", marginBottom: "3rem" }}>
                <div style={{
                  padding: "2rem",
                  backgroundColor: cardBg,
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                }}>
                  <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>👤</div>
                  <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "1rem", color: textColor }}>Management</h3>
                  <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "0.5rem" }}><strong>Kagiso Mabule</strong></p>
                  <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "0.5rem" }}>Founder & CEO</p>
                  <p style={{ fontSize: "1rem", color: subTextColor }}>Faxon Entertainment (Pty) Ltd</p>
                </div>

                <div style={{
                  padding: "2rem",
                  backgroundColor: cardBg,
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                }}>
                  <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>📧</div>
                  <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "1rem", color: textColor }}>Email</h3>
                  <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "0.5rem" }}>
                    <a href="mailto:kg.mabule@gmail.com" style={{ color: "#ff0000", textDecoration: "none", fontWeight: "600" }}>
                      kg.mabule@gmail.com
                    </a>
                  </p>
                  <p style={{ fontSize: "0.9rem", color: darkTheme ? "#777" : "#999" }}>We respond within 24h</p>
                </div>

                <div style={{
                  padding: "2rem",
                  backgroundColor: cardBg,
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                }}>
                  <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>📞</div>
                  <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "1rem", color: textColor }}>Phone</h3>
                  <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "0.5rem" }}>
                    <a href="tel:0729753757" style={{ color: "#ff0000", textDecoration: "none", fontWeight: "600" }}>
                      072 975 3757
                    </a>
                  </p>
                  <p style={{ fontSize: "0.9rem", color: darkTheme ? "#777" : "#999" }}>Mon - Fri: 9am - 6pm</p>
                </div>

                <div style={{
                  padding: "2rem",
                  backgroundColor: cardBg,
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                }}>
                  <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>💼</div>
                  <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "1rem", color: textColor }}>LinkedIn</h3>
                  <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "0.5rem" }}>
                    <a
                      href="https://www.linkedin.com/in/kagiso-mabule"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#ff0000", textDecoration: "none", fontWeight: "600" }}
                    >
                      Connect with us
                    </a>
                  </p>
                  <p style={{ fontSize: "0.9rem", color: darkTheme ? "#777" : "#999" }}>Professional network</p>
                </div>
              </div>

              <div style={{ marginTop: "3rem" }}>
                <h3 style={{ fontSize: "1.3rem", fontWeight: "600", marginBottom: "1.5rem", color: textColor }}>Follow Us</h3>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                  {[
                    { name: "Instagram", url: "https://www.instagram.com/kgbwithadash.nft/" },
                    { name: "Facebook", url: "https://facebook.com/FaxonEnt" },
                    { name: "Twitter", url: "https://twitter.com/KGbwithadash" },
                  ].map((social, i) => (
                    <a
                      key={i}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        padding: "0.8rem 1.5rem",
                        backgroundColor: cardBg,
                        color: textColor,
                        border: `1px solid ${borderColor}`,
                        borderRadius: "8px",
                        textDecoration: "none",
                        fontSize: "0.95rem",
                        fontWeight: "500",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {social.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - Contact Form */}
            <div data-aos="fade-left">
              <div style={{
                padding: "3rem",
                backgroundColor: cardBg,
                borderRadius: "12px",
                border: `1px solid ${borderColor}`,
              }}>
                <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "0.5rem", color: textColor }}>
                  Send us a Message
                </h2>
                <p style={{ fontSize: "1rem", color: subTextColor, marginBottom: "2.5rem" }}>
                  Fill out the form below and we'll get back to you within 24 hours
                </p>

                <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "0.95rem", fontWeight: "500", marginBottom: "0.5rem", color: textColor }}>
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Nomsa Thusi"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        padding: "1rem",
                        borderRadius: "8px",
                        border: `1px solid ${borderColor}`,
                        backgroundColor: inputBg,
                        color: inputColor,
                        fontSize: "1rem",
                        outline: "none",
                      }}
                    />
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "0.95rem", fontWeight: "500", marginBottom: "0.5rem", color: textColor }}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        placeholder="john@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                          padding: "1rem",
                          borderRadius: "8px",
                          border: `1px solid ${borderColor}`,
                          backgroundColor: inputBg,
                          color: inputColor,
                          fontSize: "1rem",
                          outline: "none",
                        }}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "0.95rem", fontWeight: "500", marginBottom: "0.5rem", color: textColor }}>
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="072 123 4567"
                        value={formData.phone}
                        onChange={handleChange}
                        style={{
                          padding: "1rem",
                          borderRadius: "8px",
                          border: `1px solid ${borderColor}`,
                          backgroundColor: inputBg,
                          color: inputColor,
                          fontSize: "1rem",
                          outline: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "0.95rem", fontWeight: "500", marginBottom: "0.5rem", color: textColor }}>
                      Subject *
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      style={{
                        padding: "1rem",
                        borderRadius: "8px",
                        border: `1px solid ${borderColor}`,
                        backgroundColor: inputBg,
                        color: inputColor,
                        fontSize: "1rem",
                        outline: "none",
                        appearance: "none",
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23${darkTheme ? 'aaa' : '666'}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 1rem center",
                        backgroundSize: "8px 10px",
                        paddingRight: "2.5rem",
                      }}
                    >
                      <option value="">Select a subject</option>
                      <option value="artist-management">Artist Management</option>
                      <option value="model-management">Model Management</option>
                      <option value="athlete-management">Athlete Management</option>
                      <option value="booking">Booking Inquiry</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "0.95rem", fontWeight: "500", marginBottom: "0.5rem", color: textColor }}>
                      Message *
                    </label>
                    <textarea
                      name="message"
                      placeholder="Tell us about your inquiry..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      style={{
                        padding: "1rem",
                        borderRadius: "8px",
                        border: `1px solid ${borderColor}`,
                        backgroundColor: inputBg,
                        color: inputColor,
                        fontSize: "1rem",
                        resize: "vertical",
                        outline: "none",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    style={{
                      padding: "1.2rem 2rem",
                      backgroundColor: "#ff0000",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      marginTop: "1rem",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section style={{ padding: "6rem 2rem", backgroundColor: bgColor }} data-aos="fade-up">
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            textAlign: "center",
            marginBottom: "4rem",
            color: textColor,
          }}>
            Frequently Asked Questions
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "2rem" }}>
            {[
              {
                question: "How do I join Faxon Entertainment?",
                answer:
                  "Contact us using the form above with details about your talent and experience. We'll review your profile and get back to you within 48 hours.",
              },
              {
                question: "What services do you provide?",
                answer:
                  "We offer comprehensive talent management including branding, tour management, booking coordination, career development, and strategic partnerships.",
              },
              {
                question: "Do you charge upfront fees?",
                answer:
                  "We work on a commission basis. Our fees are discussed transparently during contract negotiations and are based on industry standards.",
              },
              {
                question: "What types of talent do you represent?",
                answer:
                  "We represent artists (AmaPiano, Hip Hop), models (runway, commercial, influencers), and athletes (soccer, basketball, athletics).",
              },
            ].map((faq, i) => (
              <div
                key={i}
                style={{
                  padding: "2rem",
                  backgroundColor: cardBg,
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                }}
              >
                <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "1rem", color: textColor }}>
                  {faq.question}
                </h3>
                <p style={{ fontSize: "1rem", color: subTextColor, lineHeight: "1.7" }}>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;